module.exports = __webpack_public_path__ + "static/media/bSanders.b12ac29e.jpeg";